








import toastMixin from '@/mixin/toastMixin'
import XButton from '@/components/atoms/Button/XButton.vue'

type Props = {
  value: string
}

export default toastMixin.extend<{}, {}, {}, Props>({
  name: 'XCopyButton',
  components: {
    XButton,
  },
  methods: {
    copy(str: string) {
      navigator.clipboard.writeText(str)
      this.showToast(this.$tc('common.copied'))
    },
  },
  props: {
    value: {
      type: String,
      required: true,
    },
  },
})
